/**
 * Upload Button Component
 * 
 * Reusable button for triggering file upload dialogs.
 */

import React from 'react';
import './UploadButton.css';

/**
 * Button component that triggers file upload
 * 
 * @param {object} props - Component props
 * @param {function} props.onUploadClick - Handler for button click
 * @param {function} props.onFileChange - Handler for file input change
 * @param {React.RefObject} props.inputRef - Ref for hidden file input element
 */
export function UploadButton({ onUploadClick, onFileChange, inputRef }) {
  return (
    <div>
      <button className="upload-button" onClick={onUploadClick}>
        <b>UPLOAD NEW PROJECT</b>
      </button>
      <input
        id="upload"
        type="file"
        accept=".json"
        onChange={onFileChange}
        ref={inputRef}
        style={{ display: 'none' }}
      />
    </div>
  );
}


